var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIconTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Emails_Read-Email_read-email-circle",
    "data-name": "Emails / Read-Email / read-email-circle",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "read-email-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval_4",
    "data-name": "Oval 4",
    d: "M250.075,244.546a17.5,17.5,0,1,0-17.5-17.5A17.5,17.5,0,0,0,250.075,244.546Z",
    transform: "translate(-232.575 -209.546)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Emails_Send-Email_send-email",
    "data-name": "Emails / Send-Email / send-email",
    transform: "translate(-420.579 -79.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "send-email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_29",
    "data-name": "Shape 29",
    d: "M447.575,87.046l-22.569,9.323a.7.7,0,0,0,.08,1.318l8.489,2.359Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_30",
    "data-name": "Shape 30",
    d: "M447.575,87.046l-3.85,18.286a.9.9,0,0,1-1.376.562l-8.774-5.848Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_31",
    "data-name": "Shape 31",
    d: "M433.575,100.046v6.48a.519.519,0,0,0,.967.261l2.561-4.39",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconTeam);
export default __webpack_public_path__ + "static/media/email-icon-team.1b9be8b35e4155b4d8fae03066b33072.svg";
export { ForwardRef as ReactComponent };